import React from 'react';
import { ThemedHeader } from './header';
import { ThemedSider } from './sider';
import { Grid, Layout as AntdLayout } from 'antd';
import type { RefineThemedLayoutProps } from '@refinedev/antd';

export const ThemedLayout: React.FC<RefineThemedLayoutProps> = ({ children, Title, Footer, OffLayoutArea }) => {
  const breakpoint = Grid.useBreakpoint();

  const isSmall = typeof breakpoint.sm === 'undefined' ? true : breakpoint.sm;

  return (
    <AntdLayout style={{ minHeight: '100vh', display: 'flex' }}>
      <ThemedSider Title={Title} />
      <AntdLayout>
        <ThemedHeader />
        <AntdLayout.Content>
          <div
            style={{
              minHeight: 360,
              padding: isSmall ? 24 : 12,
            }}
          >
            {children}
          </div>
          {OffLayoutArea && <OffLayoutArea />}
        </AntdLayout.Content>
        {Footer && <Footer />}
      </AntdLayout>
    </AntdLayout>
  );
};
